export class PercentRate {
  readonly value: number;

  constructor(value: number) {
    this.value = value;
  }

  static fromPercent(percent: number): PercentRate {
    return new PercentRate(percent / 100);
  }

  get asPercent(): number {
    return this.value * 100;
  }

  add(other: PercentRate): PercentRate {
    return new PercentRate(this.value + other.value);
  }

  subtract(other: PercentRate): PercentRate {
    return new PercentRate(this.value - other.value);
  }

  multiply(scalar: number): PercentRate {
    return new PercentRate(this.value * scalar);
  }

  apply(base: number): number {
    return base * this.value;
  }

  grow(base: number): number {
    return base * (1 + this.value);
  }

  equals(other: PercentRate): boolean {
    return Math.abs(this.value - other.value) < 1e-9;
  }

  toString(): string {
    return `${this.asPercent.toFixed(1)}%`;
  }
}